import { useState } from 'react';
import { LabelInput } from '../../../components/Input/Input';
import { BUDGET_TABS } from '../../../screens/ModalBudget/utils/enum';

const tabNotes = {
  CUSTOMER_REPORT: 1,
  OBSERVATION_OS: 2,
  OBSERVATION_INT: 3,
};

export const OSNotes = (props) => {
  const { budget, onChange, values, company, printCompany } = props;

  const [currentTab, setCurrentTab] = useState(tabNotes.CUSTOMER_REPORT);

  if (budget !== BUDGET_TABS.NOTES) {
    return;
  }

  return (
    <div className="os-notes-container">
      <div className="os-notes-tabs-container">
        <div
          onClick={() => setCurrentTab(tabNotes.CUSTOMER_REPORT)}
          className={`os-notes-button-tabs ${
            currentTab === tabNotes.CUSTOMER_REPORT
              ? 'os-notes-button-tabs-enabled'
              : 'os-notes-button-tabs-disabled'
          }`}
        >
          Relato cliente
        </div>
        <div
          onClick={() => setCurrentTab(tabNotes.OBSERVATION_OS)}
          className={`os-notes-button-tabs ${
            currentTab === tabNotes.OBSERVATION_OS
              ? 'os-notes-button-tabs-enabled'
              : 'os-notes-button-tabs-disabled'
          }`}
        >
          Obs OS
        </div>
        <div
          onClick={() => setCurrentTab(tabNotes.OBSERVATION_INT)}
          className={`os-notes-button-tabs ${
            currentTab === tabNotes.OBSERVATION_INT
              ? 'os-notes-button-tabs-enabled'
              : 'os-notes-button-tabs-disabled'
          }`}
        >
          Obs int
        </div>
      </div>

      {currentTab === tabNotes.CUSTOMER_REPORT && (
        <LabelInput
          className="remove-margin"
          type={'textarea'}
          inputClassname={'os-notes-textarea'}
          onChange={(value) => onChange('customer_report', value)}
          value={values?.customer_report}
        />
      )}

      {currentTab === tabNotes.OBSERVATION_OS && (
        <LabelInput
          className="remove-margin"
          type={'textarea'}
          inputClassname={'os-notes-textarea'}
          onChange={(value) => onChange('observation_os', value)}
          value={
            values?.observation_os ||
            printCompany?.serviceOrderNote ||
            company?.serviceOrderNote ||
            ''
          }
        />
      )}

      {currentTab === tabNotes.OBSERVATION_INT && (
        <LabelInput
          className="remove-margin"
          type={'textarea'}
          inputClassname={'os-notes-textarea'}
          onChange={(value) => onChange('observation_int', value)}
          value={values?.observation_int}
        />
      )}
    </div>
  );
};
